export default __webpack_public_path__ + "static/media/warning-icon.90b7eea1.svg";